module.exports = __webpack_public_path__ + "img/Number=81.0d386cf7.png";